import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  obj2vqjd1bjrpmyg as obj,
  nullable1in0t8o94jx9t as nullable,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import {
  Data1ybn66w6c74sz as Data,
  CreateSecretg99oj6r6hso0 as CreateSecret,
} from '../CreateSecretMutation.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { listOf1jh22dvmctj1r as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_secretIdAdapter1o4zeaz9dqdiz as get_secretIdAdapter } from '../../adapter/Adapter.mjs';
import { KotlinInstantAdapter_instance19tdzzheivj7r as KotlinInstantAdapter_instance } from '../../../../../../../apollo-kotlin-adapters-apollo-adapters-core/com/apollographql/adapter/core/KotlinInstantAdapter.mjs';
import { missingField4n9ldh7pi82p as missingField } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Assertions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.n6i_1 = listOf('createSecret');
      }
      t3x(reader, customScalarAdapters) {
        var _createSecret = null;
        $l$loop: while (true) {
          if (reader.q4c(this.n6i_1) === 0)
            _createSecret = nullable(obj(CreateSecret_getInstance())).t3x(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_createSecret);
      }
      o6i(writer, customScalarAdapters, value) {
        writer.o4a('createSecret');
        nullable(obj(CreateSecret_getInstance())).y3x(writer, customScalarAdapters, value.u6c_1);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.o6i(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
var CreateSecretClass;
function CreateSecret_0() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor() {
        CreateSecret_instance = this;
        this.p6i_1 = listOf_0(['secretId', 'description', 'createdTimestamp', 'lastUsedTimestamp', 'secretToken']);
      }
      t3x(reader, customScalarAdapters) {
        var _secretId = null;
        var _description = null;
        var _createdTimestamp = null;
        var _lastUsedTimestamp = null;
        var _secretToken = null;
        $l$loop: while (true) {
          switch (reader.q4c(this.p6i_1)) {
            case 0:
              _secretId = get_secretIdAdapter().t3x(reader, customScalarAdapters);
              break;
            case 1:
              _description = get_StringAdapter().t3x(reader, customScalarAdapters);
              break;
            case 2:
              _createdTimestamp = KotlinInstantAdapter_instance.t3x(reader, customScalarAdapters);
              break;
            case 3:
              _lastUsedTimestamp = nullable(KotlinInstantAdapter_instance).t3x(reader, customScalarAdapters);
              break;
            case 4:
              _secretToken = get_StringAdapter().t3x(reader, customScalarAdapters);
              break;
            default:
              break $l$loop;
          }
        }
        var tmp1_elvis_lhs = _secretId;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          missingField(reader, 'secretId');
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp_0 = tmp;
        var tmp2_elvis_lhs = _description;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          missingField(reader, 'description');
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var tmp_2 = tmp_1;
        var tmp3_elvis_lhs = _createdTimestamp;
        var tmp_3;
        if (tmp3_elvis_lhs == null) {
          missingField(reader, 'createdTimestamp');
        } else {
          tmp_3 = tmp3_elvis_lhs;
        }
        var tmp_4 = tmp_3;
        var tmp_5 = _lastUsedTimestamp;
        var tmp4_elvis_lhs = _secretToken;
        var tmp_6;
        if (tmp4_elvis_lhs == null) {
          missingField(reader, 'secretToken');
        } else {
          tmp_6 = tmp4_elvis_lhs;
        }
        return new (CreateSecret())(tmp_0, tmp_2, tmp_4, tmp_5, tmp_6);
      }
      q6i(writer, customScalarAdapters, value) {
        writer.o4a('secretId');
        get_secretIdAdapter().u3x(writer, customScalarAdapters, value.v6c_1);
        writer.o4a('description');
        get_StringAdapter().u3x(writer, customScalarAdapters, value.w6c_1);
        writer.o4a('createdTimestamp');
        KotlinInstantAdapter_instance.x4e(writer, customScalarAdapters, value.x6c_1);
        writer.o4a('lastUsedTimestamp');
        nullable(KotlinInstantAdapter_instance).y3x(writer, customScalarAdapters, value.y6c_1);
        writer.o4a('secretToken');
        get_StringAdapter().u3x(writer, customScalarAdapters, value.z6c_1);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.q6i(writer, customScalarAdapters, value instanceof CreateSecret() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'CreateSecret', VOID, VOID, [Adapter()]);
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CreateSecret_instance;
function CreateSecret_getInstance() {
  if (CreateSecret_instance === VOID)
    new (CreateSecret_0())();
  return CreateSecret_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstanceli8gxt7gkzph,
};
//endregion

//# sourceMappingURL=CreateSecretMutation_ResponseAdapter.mjs.map
